import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Card, Tag } from "antd";
import { updateSelectedRegisterPOS } from "../../../store/actions/pos";

function RegistersList({ t, closeModal, fromCart }) {
  const registers = useSelector((state) => state.pos.registers);
  const dispatch = useDispatch();

  return (
    <div className="mb-3">
      <p>{t("Select Register")}</p>
      <div
        className="d-flex text-center "
        style={{ gap: 10, justifyContent: "space-evenly", flexWrap: "wrap" }}
      >
        {registers.map((register) => (
          <Card
            hoverable
            style={{ flex: fromCart ? "50%" : 1, width: "25%" }}
            onClick={() => {
              dispatch(updateSelectedRegisterPOS(register));
              closeModal?.();
            }}
          >
            <div>
              <h4>{register.name}</h4>
              {register.is_open && (
                <Tag
                  style={{ position: "absolute", top: 10, right: 0 }}
                  color={"blue"}
                >
                  {t("Open")}
                </Tag>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default withNamespaces()(RegistersList);
